export { default } from './ContestPlacesList';



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestView/ContestPlacesList/index.js